import * as types from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loader',
});

const state = {
    supplierList: [],
    supplier: {
        id: null,
        name: null,
        address: null,
        postal_code: null,
        city: null,
        country: null,
        outlet_id: null,
        region: null,
        contact_name: null,
        contact_no: null,
        contact_email: null,
        contact_fax: null,
        sb_flag: 0,
    },
};

const getters = {
    supplier: state => state.supplier,
    supplierList: state => state.supplierList,
    findSupplierStock: state => (supplier_id, stock_id) => {
        const supplier = state.supplierList.find(s => s.id == supplier_id);

        return !supplier
            ? undefined
            : supplier.stocks.find(stock => stock.id == stock_id);
    },
};

const mutations = {
    [types.SET_SUPPLIER_LIST](state, suppliers) {
        state.supplierList = suppliers;
    },

    [types.SET_SUPPLIER_ATTR](state, { key, value }) {
        state.supplier[key] = value;
    },

    [types.SET_SUPPLIER](state, supplier) {
        state.supplier = supplier;
    },
};

const actions = {
    async getSupplierList({ commit, dispatch }, relation = 0) {
        const route = Laroute.route('data_api.supplier_list');

        const options = {
            params: { relation },
        };

        startLoading(dispatch, 'fetch-supplier-list');

        try {
            const { data } = await axios.get(route, options);
            endLoading(dispatch, 'fetch-supplier-list');
            commit(types.SET_SUPPLIER_LIST, data);

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-supplier-list');
            throw e;
        }
    },

    async getSupplier({ commit, dispatch }, id) {
        const url = Laroute.route('supplier.show', { id });
        startLoading(dispatch, 'fetch-supplier');

        try {
            const { data } = await axios.get(url);
            commit(types.SET_SUPPLIER, data);
            endLoading(dispatch, 'fetch-supplier');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-supplier');
            throw e;
        }
    },

    async createSupplier({ dispatch, state }) {
        startLoading(dispatch, 'save-supplier');
        const url = Laroute.route('supplier.save');

        try {
            const { data } = await axios.post(url, state.supplier);
            endLoading(dispatch, 'save-supplier');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-supplier');
            throw e;
        }
    },

    async updateSupplier({ commit, dispatch, state }) {
        startLoading(dispatch, 'save-supplier');

        const id = state.supplier.id;
        const url = Laroute.route('supplier.update', { id });

        try {
            const { data } = await axios.put(url, state.supplier);
            commit(types.SET_SUPPLIER, data);
            endLoading(dispatch, 'save-supplier');

            return data;
        } catch (e) {
            endLoading(dispatch, 'save-supplier');
            throw e;
        }
    },

    async saveSupplierStock({ dispatch, state }, { stock_id, cost }) {
        startLoading(dispatch, 'save-supplier-supplier');

        const id = state.supplier.id;
        const url = Laroute.route('supplier.save_stock', { id, stock_id });

        try {
            await axios.put(url, { cost });
            endLoading(dispatch, 'save-supplier-supplier');
        } catch (e) {
            endLoading(dispatch, 'save-supplier-supplier');
            throw e;
        }
    },

    setSupplierAttr({ commit }, { key, value }) {
        commit(types.SET_SUPPLIER_ATTR, { key, value });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/supplier.js